import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  key = 'message';

  constructor(public hs: HttpService) {}

  async get_chat_subjects() {
    try {
      return await this.hs.get(`/${this.key}/get-chat-subjects`, {});
    } catch (error: any) {
      throw error;
    }
  }

  async get_eligible_recipients(subject_id: number) {
    try {
      return await this.hs.get(`/${this.key}/get-eligible-recipients`, { subject_id });
    } catch (error: any) {
      throw error;
    }
  }

  async get_conversations() {
    try {
      return await this.hs.get(`/${this.key}/get-conversations`, {});
    } catch (error: any) {
      throw error;
    }
  }

  async get_message_list(receiver_id: number, subject_id: number, page = 1, page_size = 50) {
    try {
      return await this.hs.get(`/${this.key}/get-message-list`, { receiver_id, subject_id, page, page_size });
    } catch (error: any) {
      throw error;
    }
  }

  async get_unread_count() {
    try {
      return await this.hs.get(`/${this.key}/get-unread-count`, {});
    } catch (error: any) {
      throw error;
    }
  }

  async send_message(receiver_id: number, subject_id: number, message_text: string) {
    try {
      return await this.hs.post(`/${this.key}/send-message`, {}, { receiver_id, subject_id, message_text });
    } catch (error: any) {
      throw error;
    }
  }
}
